<template>
  <div>
    <div class="section" id="menu">
      <div class="container text-center">

        <div class="language-picker-container">
          <language-selector v-model="lang" />
        </div>

        <div class="row justify-content-md-center">
          <div class="col-md-12 col-lg-8">
            <!-- Titolo tradotto -->
            <h2 class="title">{{ translatedTitle }}</h2>
            <!-- Descrizione tradotta -->
            <h5 class="description">{{ translatedDescription }}</h5>

            <div class="mt-5">
              <!-- Passa la lingua corrente al componente OSMMenu -->
              <o-s-m-menu :no-height-limit="true" :lang="lang"></o-s-m-menu>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OSMMenu from "../components/OSMMenu";
import NButton from "../components/Button";
import LanguageSelector from "../components/Inputs/LanguageSelector.vue";

export default {
  name: 'MenuPage',
  components: {
    LanguageSelector,
    OSMMenu,
    NButton,
  },
  data() {
    return {
      // Ottieni la lingua dalla rotta, di default 'fr'
      lang: null
    };
  },
  computed: {
    translatedTitle() {
      const titles = {
        fr: "Notre menu",
        en: "Our Menu",
        it: "Il nostro menù",
        nl: "Ons menu",
        de: "Unser Menü"
      };
      return titles[this.lang] || titles.fr;
    },
    translatedDescription() {
      const descriptions = {
        fr: "Découvrez les saveurs de la cuisine italienne traditionnelle",
        en: "Discover the flavors of traditional Italian cuisine",
        it: "Scopri i sapori della cucina italiana tradizionale",
        nl: "Ontdek de smaken van de traditionele Italiaanse keuken",
        de: "Entdecken Sie die Aromen der traditionellen italienischen Küche"
      };
      return descriptions[this.lang] || descriptions.fr;
    }
  }
};
</script>
<style lang="scss">
.timetable {
  tr {
    td {
      padding: 5px;
    }

    td:first-child {
      text-align: left;
      font-weight: bold;
    }
  }
}

.social-link {
  color: #000;
  font-size: 32px;
  margin-right: 15px;
}

.background-section {
  height: 500px;
  @media screen and (max-width: 768px) {
    height: auto;
  }

  position: relative;

  .section-content {
    height: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    z-index: 40;
    position: relative;
  }

  .background {
    position: absolute;
    z-index: 10;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: bottom;
  }

  &[background="gnocchi"] {
    .background {
      background-image: url('../../public/images/backgrounds/gnocchi-1920-1080.jpg');
    }
  }

  &[background="vini"] {
    .background {
      background-image: url('../../public/images/backgrounds/tappi-1920-1080.jpg');
    }
  }

  &[background="dessert"] {
    .background {
      background-image: url('../../public/images/backgrounds/tiramisu-1920-1080.jpg');
    }
  }

  &[background="pizze"] {
    .background {
      background-image: url('../../public/images/bg-pizza-compressed.jpg');
      background-position: center;
      @media screen and (max-width: 768px) {
        background-position: left;
      }
    }
  }

  .content {
    padding: 15px;

    &.content-right {
      @media screen and (min-width: 1024px) {
        width: 50%;
      }
    }

    &.content-center {
      width: 70%;
      margin: 0 auto;
      text-align: center;
    }
  }
}

.modal .modal-header .close {
  z-index: 999999;
}

.modal .modal-dialog .modal-content {
  max-height: 95vh;
  overflow: auto;
}
.btn-xl{
  font-size: 2em !important;
  @media screen and (max-width: 500px){
    font-size: 1.4em !important;
    width: 100%;
    padding: 15px;
  }
}
</style>
